var exports = {
  "F4": "onboardingPopover__TO2jE1",
  "lv": "popoverContent__NkqaQC",
  "_m": "popoverHeading___yxU_o",
  "cm": "popoverBody__TFSTNW",
  "vv": "actionButtonStack__dy3Cd0",
};

module.exports = exports;
